import { render, staticRenderFns } from "./Roles.vue?vue&type=template&id=5d4ef04d&scoped=true"
import script from "./Roles.vue?vue&type=script&lang=js"
export * from "./Roles.vue?vue&type=script&lang=js"
import style1 from "vue-multiselect-listbox/dist/vue-multi-select-listbox.css?vue&type=style&index=1&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d4ef04d",
  null
  
)

export default component.exports